import { formatUrlId, parseUrlId } from '@cargoflow/validators'
import { createFileRoute, stripSearchParams } from '@tanstack/react-router'
import { z } from 'zod'
import { DEFAULT_RADIUS_KM } from '@/features/matching/components/matching-filters'
import { LoadMatchView } from '@/features/matching/load-match-view'

const searchSchema = z.object({
  radius_km: z.coerce.number().positive().max(500).default(DEFAULT_RADIUS_KM),
})

export const Route = createFileRoute('/_authenticated/matching/$load_id/$route_id')({
  params: {
    parse: ({ load_id, route_id }) => ({
      load_id: parseUrlId(load_id),
      route_id: parseUrlId(route_id),
    }),
    stringify: ({ load_id, route_id }) => ({
      load_id: formatUrlId('LD', load_id),
      route_id: formatUrlId('RT', route_id),
    }),
  },
  validateSearch: searchSchema,
  // Keep the default radius out of the URL; only a user-chosen non-default value
  // (which changes the score) is persisted so the link stays correct + shareable.
  search: { middlewares: [stripSearchParams({ radius_km: DEFAULT_RADIUS_KM })] },
  component: LoadMatchView,
})
